<div class="padding">
<div class="carousel carousel-showmanymoveone slide" id="carousel-tilenav" data-interval="false">
  <div class="carousel-inner">
    <div class="panel panel-default">
      <div class="panel-heading">
        <p class="panel-title">Firmwide CAT Summary</p>
      </div>
      <div class="panel-body nopadding">
        <!-- Firmwide CAT Summary -->
        <div class="col-lg-12 nopadding">
          <ng-container>
            <div class="col-md-3 nopadding"></div>
            <div class="col-md-1 nopadding dtop-3"><a class="btn-bg-color-dark-blue float-right" matTooltip="Prev" [matTooltipShowDelay]="1000" (click)="clickLeft()" data-slide="prev">
              <em class="fa fa-backward"></em></a></div>
            <div class="col-md-4">
            <p-datepicker [touchUI]="true" [(ngModel)]="LastCATExecutionDate" dateFormat="yy-mm-dd" (onSelect)="getData()"  placeholder="Date" [showIcon]="true" size="small" iconDisplay="input" appendTo="body" [showOnFocus]="false"
            [motionOptions]="{ duration: 0 }"/>
            </div>
            <div class="col-md-1 nopadding dtop-3"><a class="btn-bg-color-dark-blue float-left" matTooltip="Next" [matTooltipShowDelay]="1000" (click)="clickRight()" data-slide="next">
              <em class="fa fa-forward"></em></a></div>
            <div class="col-md-3 nopadding"></div>
          </ng-container>
        </div>
        <div class="col-lg-12 nopadding">
          @if(isLoadingResults){
            <div class="example-loading-shade">
              @if(isLoadingResults){
                <mat-spinner diameter="30"></mat-spinner>
              }
            </div>
          }
          <p-table [value]="transactionData" [scrollable]="true" scrollHeight="300px" [tableStyle]="{'min-width': 'autoWidth'}" showGridlines>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="3" class="text-center">
                  {{tbldatamsg}}
                </td>
              </tr>
            </ng-template>
            <ng-template #header>
              <tr>
                <th id="colCATReporterIMID" pSortableColumn="CATReporterIMID">MPID <p-sortIcon field="CATReporterIMID" /></th>
                <th id="coltotalCATROEs" class="text-right" pSortableColumn="totalCATROEs">CAT-ROE Count <p-sortIcon field="totalCATROEs" /></th>
                <th id="coltotalOpenFinraExceptions" class="text-right" pSortableColumn="totalOpenFinraExceptions">Finra-Exception Count <p-sortIcon field="totalOpenFinraExceptions" /></th>
              </tr>
            </ng-template>
            <ng-template #body let-transaction>
              <tr>
                <td class="text-center"><a>{{transaction.CATReporterIMID}}</a></td>
                <td class="text-right">
                  <a matTooltip="View CAT ROE Details" [matTooltipShowDelay]="1000" appendTo="body" [class]="'text-blue'"
                  (click)="goToScreenViewer(transaction, 'CAT-ROE')">
                    {{transaction.totalCATROEs | number }}
                  </a>
                </td>
                <td class="text-right">
                  <a matTooltip="View Finra Exception Details" [matTooltipShowDelay]="1000" appendTo="body" [class]="'text-blue'"
                  (click)="goToScreenViewer(transaction, 'FINRA-EXCEPTION')">
                    {{transaction.totalOpenFinraExceptions | number }}
                  </a>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <!-- End of Firmwide CAT Summary -->
      </div>
    </div>
  </div>
</div>
</div>